module.exports = __webpack_public_path__ + "static/media/es-ga.ec306dbd.svg";